import moment from "moment-timezone";

export type CalendarSlot = {
  label: string;
  hour: number;
  offsetMinutes: number;
};

export type CalendarSlotChoice = {
  slot: string;
  label: string;
};

/**
 * Local label for a UTC slot in the booking timezone.
 * Parsed as UTC first, same as convertToTimeZone, so an offset-less string
 * is not read as local wall time.
 */
export function describeCalendarSlot(
  slot: string,
  timeZone: string
): CalendarSlot {
  const local = moment.utc(slot).tz(timeZone);
  return {
    label: local.format("hh:mm A"),
    hour: local.hour(),
    offsetMinutes: local.utcOffset(),
  };
}

/**
 * Morning is local hour < 12. Labels are already in the booking timezone.
 */
export function splitCalendarSlots(
  slots: string[] | null | undefined,
  timeZone: string
): { morning: CalendarSlotChoice[]; evening: CalendarSlotChoice[] } {
  const morning: CalendarSlotChoice[] = [];
  const evening: CalendarSlotChoice[] = [];
  (slots ?? []).forEach((slot) => {
    const described = describeCalendarSlot(slot, timeZone);
    const choice = { slot, label: described.label };
    if (described.hour < 12) {
      morning.push(choice);
    } else {
      evening.push(choice);
    }
  });
  return { morning, evening };
}
